const Chrome = () => {
  return (
    <svg
      xmlns="http://www.w3.org/2000/svg"
      width="32"
      height="32"
      viewBox="0 0 32 32"
      fill="none"
      data-testid="chrome-icon"
    >
      <path
        d="M16 22.9971C19.866 22.9971 23 19.863 23 15.9971C23 12.1311 19.866 8.99707 16 8.99707C12.134 8.99707 9 12.1311 9 15.9971C9 19.863 12.134 22.9971 16 22.9971Z"
        fill="white"
      />
      <path
        d="M16.0021 9.00002H28.1245C26.8961 6.87166 25.129 5.10423 23.0009 3.87544C20.8727 2.64666 18.4586 1.99983 16.0012 2C13.5438 2.00017 11.1298 2.64734 9.0018 3.87642C6.87385 5.1055 5.10699 6.87318 3.87891 9.00171L9.94008 19.5L9.94551 19.4986C9.32892 18.4353 9.00354 17.2283 9.00216 15.9992C9.00078 14.7701 9.32345 13.5624 9.93764 12.4977C10.5518 11.4331 11.4358 10.5492 12.5005 9.93511C13.5653 9.32104 14.773 8.9985 16.0021 9.00002Z"
        fill="url(#paint0_linear_6735_2157)"
      />
      <path
        d="M15.9987 21.5418C19.0593 21.5418 21.5403 19.0607 21.5403 16.0002C21.5403 12.9396 19.0593 10.4585 15.9987 10.4585C12.9381 10.4585 10.457 12.9396 10.457 16.0002C10.457 19.0607 12.9381 21.5418 15.9987 21.5418Z"
        fill="#1A73E8"
      />
      <path
        d="M22.0598 19.5018L15.9986 30.0001C18.456 30.0005 20.8702 29.3538 22.9984 28.1252C25.1266 26.8965 26.8938 25.1292 28.1223 23.001C29.3509 20.8727 29.9974 18.4585 29.997 16.0011C29.9966 13.5437 29.3491 11.1298 28.1198 9.00195H15.9976L15.9961 9.00738C17.2252 9.00501 18.4332 9.32671 19.4983 9.94006C20.5635 10.5534 21.4481 11.4367 22.063 12.5009C22.6779 13.5652 23.0014 14.7727 23.0008 16.0018C23.0003 17.2309 22.6757 18.4382 22.0598 19.5018Z"
        fill="url(#paint1_linear_6735_2157)"
      />
      <path
        d="M9.93931 19.5017L3.87814 9.00342C2.64913 11.1314 2.00204 13.5455 2.00195 16.0029C2.00186 18.4603 2.64876 20.8744 3.87762 23.0025C5.10647 25.1306 6.87395 26.8976 9.00234 28.126C11.1307 29.3543 13.545 30.0006 16.0024 29.9999L22.0636 19.5016L22.0597 19.4976C21.4472 20.5632 20.5645 21.4485 19.5008 22.0643C18.4371 22.68 17.2298 23.0045 16.0007 23.0049C14.7716 23.0053 13.5641 22.6817 12.4999 22.0666C11.4358 21.4516 10.5525 20.5669 9.93931 19.5017Z"
        fill="url(#paint2_linear_6735_2157)"
      />
      <defs>
        <linearGradient
          id="paint0_linear_6735_2157"
          x1="3.87891"
          y1="10.75"
          x2="28.1245"
          y2="10.75"
          gradientUnits="userSpaceOnUse"
        >
          <stop stopColor="#D93025" />
          <stop offset="1" stopColor="#EA4335" />
        </linearGradient>
        <linearGradient
          id="paint1_linear_6735_2157"
          x1="14.086"
          y1="29.8129"
          x2="26.2088"
          y2="8.81564"
          gradientUnits="userSpaceOnUse"
        >
          <stop stopColor="#FCC934" />
          <stop offset="1" stopColor="#FBBC04" />
        </linearGradient>
        <linearGradient
          id="paint2_linear_6735_2157"
          x1="17.5165"
          y1="29.1258"
          x2="5.39369"
          y2="8.12842"
          gradientUnits="userSpaceOnUse"
        >
          <stop stopColor="#1E8E3E" />
          <stop offset="1" stopColor="#34A853" />
        </linearGradient>
      </defs>
    </svg>
  );
};
export default Chrome;
